import React, { useMemo, useCallback } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

import DescriptionIcon from '@mui/icons-material/Description';
import LinkIcon from '@mui/icons-material/Link';

import TSTable, {
  EditButtonTableCell,
  DeleteButtonTableCell,
  SwitchTableCell,
  DateTableCell,
} from '@ts-core/components/Table';

const DocumentsTable = (props) => {
  const {
    documents,
    loading,
    onRemove,
    onEdit,
    onToggle,
    onReorder,
    onSelect,
  } = props;
  const intl = useIntl();

  const getActionsCell = useCallback(
    (_value, _, mediaItem) => {
      return (
        <Box display="flex" justifyContent="flex-end">
          <EditButtonTableCell item={mediaItem} onClick={onEdit} />
          <Box width={24} />
          <DeleteButtonTableCell
            message={intl.formatMessage(
              {
                id: 'dialog.confirmRemoveItem.title',
              },
              { item: mediaItem.name }
            )}
            item={mediaItem}
            onConfirm={onRemove}
          />
        </Box>
      );
    },
    [intl, onEdit, onRemove]
  );

  const columns = useMemo(() => {
    return [
      {
        Header: '',
        accessor: '_id',
        valueTransformer: (_value, _, mediaItem) => (
          <SwitchTableCell item={mediaItem} onChange={onToggle} />
        ),
      },
      {
        accessor: '_id',
        valueTransformer: (_value, _, mediaItem) =>
          mediaItem.isExternal ? (
            <LinkIcon fontSize="large" />
          ) : (
            <DescriptionIcon fontSize="large" />
          ),
      },
      {
        Header: intl.formatMessage({ id: 'field.name.label' }),
        accessor: 'name',
      },
      {
        Header: intl.formatMessage({ id: 'createdAt' }),
        accessor: 'createdAt',
        valueTransformer: (value) => <DateTableCell date={value} />,
      },
      { Header: '', accessor: '_id', valueTransformer: getActionsCell },
    ];
  }, [intl, getActionsCell, onToggle]);

  return (
    <Box mt={1}>
      <TSTable
        data={documents}
        loading={loading}
        columns={columns}
        onSelectRow={onSelect}
        onSortEnd={onReorder}
      />
    </Box>
  );
};

DocumentsTable.propTypes = {
  documents: PropTypes.array,
  loading: PropTypes.bool,

  onRemove: PropTypes.func,
  onEdit: PropTypes.func,
  onToggle: PropTypes.func,
  onReorder: PropTypes.func,
  onSelect: PropTypes.func,
};

DocumentsTable.defaultProps = {
  documents: [],
  loading: false,

  onRemove: undefined,
  onEdit: undefined,
  onToggle: undefined,
  onReorder: undefined,
  onSelect: undefined,
};

export default DocumentsTable;
